import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";
import { errorMessage } from "@/lib/api";
import { LangToggle } from "@/components/SiteHeader";

export default function AdminLogin() {
  const { t } = useLang();
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (ex) {
      setErr(errorMessage(ex, t));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain relative grid min-h-screen place-items-center px-5" data-testid="admin-login-page">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-96 w-96 -translate-x-1/2 rounded-full bg-smoke/30 blur-[120px]" />
      <LangToggle className="absolute right-5 top-5" />
      <form onSubmit={submit} className="panel relative w-full max-w-sm p-8">
        <img src="/brand/logo-sm.png" alt="MC Illusions Prints" className="mx-auto h-24 w-auto" />
        <h1 className="mt-5 text-center font-display text-2xl">{t("admin.login_title")}</h1>
        <label className="mt-6 block"><span className="label">{t("admin.email")}</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="field" required data-testid="admin-login-email" /></label>
        <label className="mt-4 block"><span className="label">{t("admin.password")}</span><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="field" required data-testid="admin-login-password" /></label>
        {err && <p className="mt-4 text-sm font-bold text-ruby" data-testid="admin-login-error">{err}</p>}
        <button className="btn-gold mt-6 w-full" disabled={busy} data-testid="admin-login-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} {t("admin.sign_in")}</button>
      </form>
    </div>
  );
}
